import { inject } from 'mobx-react';
import { MenuV2Component } from './component';
export const MenuV2 = inject(({ ui }) => ({
    hidden: ui.hideMenu || ui.uiVersion === 'V1',
}))(MenuV2Component);
//# sourceMappingURL=index.js.map